<template>
  <div class="outerBox" ref="outerDom" @scroll="getScrollTop">
    <div class="home">
        <div class="headBox">
            <headNav :activeMenu="2"></headNav>
        </div>
        <div class="homeContent">
            <div class="banner mobile-hide">
                <div class="search">
                    <div class="search_input">
                        <img class="searchIcon" src="../../assets/policyPage/searcIcon.png" alt="">
                        <el-input v-model="keyWord" placeholder="请输入搜索关键词" @keyup.enter.native="getSearch()"></el-input>
                    </div>
                    <div class="searchBtn" @click="getSearch">搜索</div>
                </div>
            </div>
            <div class="banner pc-hide">
                    <div class="banner-box">
                        <div class="banner-title fontStyle32">政策服务</div>
                        <div class="banner-subtitle fontStyle20">关注最新动态，了解数字化转型最新政策</div>
                    </div>
                    <!-- <div class="search">
                        <div class="search_input">
                            <img class="searchIcon" src="../../assets/policyPage/searcIcon.png" alt="">
                            <el-input v-model="keyWord" placeholder="请输入搜索关键词"
                                @keyup.enter.native="getDataList()"></el-input>
                        </div>
                        <div class="searchBtn" @click="getDataList()">搜索</div>
                    </div> -->
                </div>
            <div class="mainContent">
                <div class="policyFile">
                    <div class="policy_title">政策文件</div>
                    <div class="policy_titleText">提供数字化转型政策文件</div>
                    <div class="file_content flex">
                        <div class="file_left">
                            <div class="file_left_top">
                                <div class="file_left_title font-bold">最新政策推荐</div>
                                <div class="file_left_text">智能分析，科学配置资源，各项热门政策推荐</div>
                            </div>
                            <div class="file_left_selectBox">
                                <div class="file_left_select flex" v-for="(item,index) in policySelectList" :key="index" 
                                :class="policySelectFlag==item.id? 'file_left_selectBg':''" @click="changePolicySelect(item.id)">
                                    <div>{{item.title}}</div>
                                    <img src="../../assets/policyPage/rightArrow.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="file_right">
                            <div class="f_r_top flex" :style="{justifyContent:policySelectFlag==4?'flex-end':'space-between'}">
                                <div class="flex" v-if="policySelectFlag!=4">
                                    <div class="sort" :class="newsOrder=='0'?'sortActive':''" @click="getOrder('0')">默认排序</div>
                                    <div class="sort flex sortAI" @click="getOrder('1')">
                                        <span :class="changeOrder=='1'?'sortActive':''">发布时间</span>
                                        <div class="arrowBox flex">
                                            <div class="arrow1 el-icon-arrow-up" :class="newsOrder=='asc'?'sortActive':''" ></div>
                                            <div class="arrow2 el-icon-arrow-down" :class="newsOrder=='desc'?'sortActive':''" ></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="totalResult">
                                    <span>共</span>
                                    <span>{{newsTotal}}</span>
                                    <span>条结果</span>
                                </div>
                            </div>
                            <div class="f_r_middle">
                                <div class="fileInfo" v-if="newsTotal>0" v-for="(item,index) in newsList" :key="index" @click="pagetoInfo(item,policySelectFlag==4?item.type:'')">
                                    <div class="fileInfo_l">
                                        <div class="info_title textOverflow font-bold">{{ item.title }}</div>
                                        <div class="fileInfo_r">查看详情 >></div>
                                    </div>
                                    <div class="info_content textOverflow">{{ item.pureText }}</div>
                                    <div class="flex">
                                            <div class="info_type flex items-center textOverflow info_type_bm" v-if="item.issuingUnit">{{item.issuingUnit}}</div>
                                            <div class="info_type flex items-center textOverflow info_type_time">{{ item.releaseDate }}</div>
                                        </div>
                                    
                                </div>
                                <div class="noData" v-if="newsTotal==0">
                                    <img src="../../assets/homepage/no-data.png" alt="">
                                    <div class="noDataText fontStyle18">暂无数据</div>
                                </div>
                            </div>
                            <div class="f_r_bottom">
                                <el-pagination
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="limit"
                                    layout="prev, pager, next"
                                    :total="newsTotal"
                                    >
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="policyInterpret" v-if="false">
                    <div class="policy_title">政策解读</div>
                    <div class="policy_titleText">深度解读数字化转型有关政策文件</div>
                    <div class="interpretType flex">
                        <div class="interpretType_small flex" :class="interpretTypeFlag===index? 'interpretColor2':'interpretColor1'" 
                        v-for="(item,index) in interpretTypeList" :key="index" @click="changeinterpretType(index)">
                            <div class="interpretType_icon">
                                <img :src="item.icon" alt="">
                            </div>
                            <div class="interpretType_info flex">
                                <div class="interpretType_i_title">{{item.title}}</div>
                                <div class="interpretType_i_text">{{item.text}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="interpretContent flex" v-if="policyInterpretationList.length>0">
                        <div  v-for="(item,index) in policyInterpretationList" :key="index" :class="(index+1) % 3 != 0? 'interpret_small_margin':''">
                            <div v-if="item.type==1" class="interpret_small interpret_small_padding interpret_smallHover">
                                <div class="interpret_s_title flex">
                                    <img class="interpret_titleIcon" src="../../assets/policyPage/interpret_titleIcon.png" alt="">
                                    <span class="textOverflow">{{item.title}}</span>
                                </div>
                                <div class="interpret_s_content">{{item.pureText}}</div>
                                <div class="flex">
                                    <div class="info_type flex info_type_bm">{{item.issuingUnit}}</div>
                                    <div class="info_type flex info_type_time">{{item.releaseDate}}</div>
                                </div>
                                <div class="interpret_detailsBtn" @click="pagetoInfo(item,'1')">
                                    <span>查看详情 >></span>
                                </div>
                            </div>
                            <div v-if="item.type==2" class="interpret_small interpret_small_padding2">
                                <div class="tpjdImg">
                                    <el-image :src="item.img" fit="contain"></el-image>
                                </div>
                                <div class="tpjdLine"></div>
                                <div class="tpjdText textOverflow" @click="pagetoInfo(item,'2')">{{item.title}}</div>
                            </div>
                            <div v-if="item.type==3" class="interpret_small">
                                <video :id="`myVideo${index+1}`" width="100%" height="100%">
                                    <source :src="item.img" type="video/mp4" />
                                    <!-- <source :src="videourl" type="video/mp4" /> -->
                                    
                                </video>
                                    <img v-if="item.playFlag == 1" class="videoPlaybtn" src="../../assets/policyPage/videoPlayBtn.png" alt="">
                                    <img v-if="item.playFlag == 2" class="videoPlaybtn" src="../../assets/policyPage/videoPlayBtn2.png" alt="">
                                    <div class="videoMask" @click="playVideo(index)" @mouseenter="enterleaveVideo(index,'enter')" @mouseleave="enterleaveVideo(index,'leave')"></div>
                                <div class="spjdText textOverflow" @click="pagetoInfo(item,'3')">{{item.title}}</div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="noData" v-if="policyInterpretationList.length==0">
                        <img src="../../assets/homepage/no-data.png" alt="">
                        <div class="noDataText fontStyle18">暂无数据</div>
                    </div>
                    <div class="f_r_bottom paging" v-if="policyInterpretationList.length>0">
                        <el-pagination
                            @current-change="handleCurrentChange2"
                            :current-page.sync="currentPage2"
                            :page-size="limit2"
                            layout="prev, pager, next"
                            :total="total2"
                            :pager-count="9">
                        </el-pagination>
                    </div>
                </div>
            </div>
            
        </div>
        <bottom></bottom>
    </div>
    <div class="scrollBox" v-show="isShow" @click="goBack"></div>
  </div>
</template>

<script>
import headNav from '@/components/headNav.vue'
import bottom from '@/components/bottom.vue'
export default {
    name:'policy',
    components:{
        headNav,
        bottom
    },
    data() {
        return {
            scrollTop: 0, //默认距离顶部的距离
			isShow: false, //控制返回顶部按钮的显隐
			scrollTrigger: false, //默认初始值
            keyWord:'',
            policySelectList: [
                { title: '全部政策', id:0},
                { title: '国家级政策',id:1},
                { title: '市级政策',id:2},
                { title: '区级政策',id:3 },
                { title: '政策解读',id:4 }
            ],
            newsList:[],
            newsTotal:0,
            policySelectFlag:0,
            currentPage:1,
            limit:10,
            total:100,
            newsOrder:'0',
            interpretTypeList:[{
                icon:require('../../assets/policyPage/interpret_allIcon.png'),
                title:'全部',
                text:'深度解读政策文件'
            },{
                icon:require('../../assets/policyPage/interpret_charactersIcon.png'),
                title:'文字解读',
                text:'深度文字解读相关政策'
            },{
                icon:require('../../assets/policyPage/interpret_photoicon.png'),
                title:'图文解读',
                text:'图片与文字解读相关政策'
            },{
                icon:require('../../assets/policyPage/interpret_videoIcon.png'),
                title:'视频解读',
                text:'深度视频解读相关政策'
            },],
            interpretTypeFlag:0,
            policyInterpretationList:[],
            currentPage2:1,
            limit2:9,
            total2:0,
            changeOrder:0,
            imgUrl: this.$url.imageUrl,
        }
    },
    mounted() {
        // 增加浏览量
		this.$api.post('/digital/statisticsNumber/increase').then((res) => { })
        if(this.$route.params.flag){
            this.policySelectFlag = this.$route.params.flag
            this.getList()
        }else if(sessionStorage.getItem('pageType')){
            this.policySelectFlag = sessionStorage.getItem('pageType')
            sessionStorage.setItem('pageType', '')
            if(this.policySelectFlag ==4){
                this.getInterpretationList()
            }else{
                this.getList()
            }
        }else{
            this.policySelectFlag = 0
            this.getList()
        }
        // this.getInterpretationList()
    },
    methods: {
        getSearch(){
            this.currentPage = 1
            this.currentPage2 = 1
            this.total2 = 0
            this.newsTotal = 0
            if(this.policySelectFlag==4){
                this.getInterpretationList()
            }else{
                this.getList()
            }
        },
        getOrder(val){
            this.changeOrder = val
            this.currentPage = 1
            if(val == '0'){
                this.newsOrder = 0
            }else{

                this.newsOrder = this.newsOrder=='asc'?'desc':'asc'
            }
            this.getList()
        },
        pagetoInfo(item,type){
            this.$router.push({
					path: '/policyInfo',
					query: {
						id: item.id,
                        code:type,
                        type:this.policySelectFlag
					}
				})
        },
        getList(){
            this.$api.get(
				'/digital/policy/page',
				{
					params: {
						order: this.newsOrder==0?'desc':this.newsOrder,
						orderField: 'release_date',
						page: this.currentPage,
						limit: this.limit,
						isRelease: 1,
						type:1,
                        title:this.keyWord,
                        level:this.policySelectFlag==0?'':this.policySelectFlag
					}
				}
			).then((res) => {
				this.dataListLoading = false
				if (res.code !== 0) {
					this.newsList = []
				} else {
					this.newsList = res.data.list
					this.newsTotal = res.data.total
				}

			}).catch(() => {
				this.dataListLoading = false
			})
        },
        getInterpretationList(){
            this.$api.get(
				'/digital/policyDecode/page',
				{
					params: {
						order: 'desc',
						orderField: 'release_date',
						page: this.currentPage2,
						limit: this.limit,
						isRelease: 1,
                        title:this.keyWord,
						// type:this.interpretTypeFlag==0?'':this.interpretTypeFlag
					}
				}
			).then((res) => {
				this.dataListLoading = false
				if (res.code !== 0) {
                    this.newsList = []
					// this.policyInterpretationList = []
				} else {
                    this.newsList = res.data.list
                    this.newsTotal = res.data.total
					// this.policyInterpretationList = res.data.list
                    // this.policyInterpretationList.forEach(item => {
                    //     item.img = ''
                    //     if(!(item.uploadFiles==''||item.uploadFiles==null)){
                    //         item.uploadFilesArr = JSON.parse(item.uploadFiles)
                    //         item.img = this.imgUrl + item.uploadFilesArr[0].filepath
                    //     }
                    //     if(item.type==3){
                    //         item.playFlag = 1
                    //     }
                        
                    // })
                    // console.log(this.policyInterpretationList)
					// this.total2 = res.data.total
				}

			}).catch(() => {
				this.dataListLoading = false
			})
        },
        // 返回顶部事件
		goBack() {
			let that = this; // 防止this指向问题
			// 防止频繁点击，故返回顶部后设置scrollTrigger为初始值
			if (that.scrollTrigger) {
				return;
			}
			// 获取当前距离顶部的距离
			let scrollTop = this.scrollTop;
			
			let steep = scrollTop / 2000;
			let timer = setInterval(() => {
				that.scrollTrigger = true;
				// 滚动的速度逐渐变快，第一次走2000/1，然后减去已走的距离，下一次用剩下的距离再减去步进值，步进值也是不断变化，这样速度会越来越快
				scrollTop -= steep;
				// 步进值不改变的话会匀速缓慢上滑，不断增加步进值上滑的距离增加，视觉效果速度变快
				steep += 20;
				if (scrollTop <= 0) {
					clearInterval(timer);
					that.scrollTrigger = false;
				}
				that.$refs.outerDom.scrollTop = scrollTop;
			}, 30);
		},
		// 监听滚动条
		getScrollTop(e) {
			let that = this; // 防止this指向问题
			// 设备一屏的高度
			let clientHeight =
				document.documentElement.clientHeight || document.body.clientHeight;
			let scrollTop = e.srcElement.scrollTop;
			this.scrollTop = scrollTop;
			// 判断距离顶部多少显示回到顶部图标
			if (scrollTop > clientHeight) {
				that.isShow = true;
			} else {
				that.isShow = false;
			}
		},
        changePolicySelect(index){
            this.policySelectFlag = index
            this.currentPage = 1
            this.newsTotal = 0
            if(index==4){
                this.getInterpretationList()
            }else{
                this.getList()
            }
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.getList()
        },
        changeinterpretType(index){
            this.interpretTypeFlag = index
            this.currentPage2 = 1
            this.getInterpretationList()
        },
        playVideo(index){
            let videoId = 'myVideo' + (index+1)
            let myVideo = document.getElementById(videoId);
            if (myVideo.paused) {
                myVideo.play();
                // this.policyInterpretationList[index].playFlag = 2
                this.$set(this.policyInterpretationList[index],'playFlag',2)
            } else {
                myVideo.pause();
                // this.policyInterpretationList[index].playFlag = 1
                this.$set(this.policyInterpretationList[index],'playFlag',1)
            }
            this.$forceUpdate()
            // myVideo.addEventListener('ended', () => {
            //     this.policyInterpretationList[index].playFlag = 1
            // });
        },
        enterleaveVideo(index,type){
            // let videoId = 'myVideo' + (index+1);
            // let myVideo = document.getElementById(videoId);
            // if(type === 'enter'){
            //      if (myVideo.paused) {
            //         this.policyInterpretationList[index].playFlag = 1
            //     } else {
            //         this.policyInterpretationList[index].playFlag = 2
            //     }
            // }else{
            //     if (!myVideo.paused) {
            //         this.policyInterpretationList[index].playFlag = -1
            //     }
            // }
           
        },
        handleCurrentChange2(val){
            this.currentPage2 = val
            this.getInterpretationList()

        },
    },
}
</script>

<style scoped>
.outerBox {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	overflow-y: auto;
}

/* 返回顶部样式 */
.scrollBox {
	position: fixed;
	right: 10px;
	bottom: 60px;
	font-size: 22px;
	z-index: 99;
	width: 70px;
	height: 70px;
	background: url('../../../src/assets/project/backTop.png') no-repeat;
	background-size: 100% 100%;
	cursor: pointer;
}

.scrollBox:hover {
	position: fixed;
	right: 10px;
	bottom: 60px;
	font-size: 22px;
	z-index: 99;
	width: 70px;
	height: 70px;
	background: url('../../../src/assets/project/backTop1.png') no-repeat;
	background-size: 100% 100%;
}

.scrollBox img {
	width: 100%;
	height: 100%;
	cursor: pointer;
}

.home{
    position: relative;
}
.headBox{
    position: absolute;
    width: 100%;
}
.homeContent {
	width: 100%;
	background: #fff url('../../assets/homepage/home-bottom.png') no-repeat;
	background-position: bottom;
    padding-bottom: 25px;
}
.flex{
    display: flex;
}

.banner{
    position: relative;
    width: 100%;
    height: 3.68rem;
    background: url('../../assets/policyPage/policy_banner.png') no-repeat;
    background-size: 100% 100%;
}
.banner .search{
    display: flex;
    position: absolute;
    bottom: .42rem;
    left: 2.6rem;
    width: 5.78rem;
    height: .5rem;
    /* background-color: pink; */
}
.banner .search .search_input{
    display: flex;
    align-items: center;
    background-color: #ffffff;
}
.banner .search .searchIcon{
    width: .26rem;
    height: .26rem;
    margin-left: .18rem;
}
.banner .search >>> .el-input{
    width: 4rem;
    font-size: .16rem;
}
.banner .search >>> .el-input .el-input__inner{
    width: 100%;
    height: .5rem;
    border: none;
    color: #000;
    border-radius:0;
}
.banner .search >>> .el-input__inner::placeholder {
    color: #888888;
}
.banner .search .searchBtn{
    width: 1rem;
    height: 100%;
    line-height: .5rem;
    font-size: .22rem;
    padding-left: .3rem;
    color: #fff;
    background: url('../../assets/policyPage/searchBtnBg.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}
.mainContent{
    width: 14rem;
    margin: 0 auto;
}
.policyFile{
    width: 100%;
    padding: .3rem 0;
}
.policy_title{
    font-size: .30rem;
    font-weight: 500;
    text-align: center;
    font-weight:bold;
    letter-spacing: 5px;
    /* color: #000; */
}
.policy_titleText{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .20rem;
    color: #68718B;
    text-align: center;
    margin-top: .15rem;
}
.policy_titleText::before{
    content: '';
    display: inline-block;
    width: 1rem;
    height: .04rem;
    margin-right: .15rem;
    border-radius: .1rem;
    background-color: #999999;
}
.policy_titleText::after{
    content: '';
    display: inline-block;
    width: 1rem;
    height: .04rem;
    margin-left: .15rem;
    border-radius: .1rem;
    background-color: #999999;
}
.file_content{
    width: 100%;
    height: 10.7rem;
    margin-top: .26rem;
    border-radius: .15rem;
    background-color: #ECF5FF;
    box-shadow: 0 0 .1rem rgba(0, 0, 0, 0.2);
}
.file_left{
    width: 3.6rem;
    height: 100%;
    background: url('../../assets/policyPage/policyBg1.png') no-repeat;
    background-size: 100% 100%;
}
.file_left_top{
    padding: .4rem .25rem;
    color: #ffffff;
}
.file_left_title{
    font-size: .26rem;
}
.file_left_text{
    font-size: .18rem;
    margin-top: .09rem;
}
.file_left_selectBox{
    color: #ffffff;
    font-size: .2rem;
}
.file_left_select{
    justify-content: space-between;
    align-items: center;
    height: .6rem;
    padding: 0 .42rem;
    cursor: pointer;
    margin-bottom: .25rem;
    
}
.file_left_select:hover{
    background: url('../../assets/policyPage/selectBg.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.22rem;
}
.file_left_selectBg{
    background: url('../../assets/policyPage/selectBg.png') no-repeat;
    background-size: 100% 100%;
}
.file_right{
    width: calc(100% - 3.6rem);
    height: 100%;
    border-radius: 0 .15rem .15rem 0;
}
.f_r_top{
    align-items: center;
    justify-content: space-between;
    height: .53rem;
}
.f_r_top .sort{
    font-size: .14rem;
    color: #666666;
    margin-left: .32rem;
    cursor: pointer;
    text-align: center;
}
.f_r_top .sort:hover{
    color: #1280F9;
    /* font-size: .2rem; */
}
.sortActive{
    color: #1280F9!important;
}
.sortAI{
    align-items: center;
}
.f_r_top .arrowBox{
    position: relative;
    flex-direction: column;
    margin-left: .05rem;
}
.f_r_top .arrow1{
    position: absolute;
    top: -0.14rem;
}
.f_r_top .arrow2{
    position: absolute;
    top: -0.03rem;
}
.f_r_top .totalResult{
    font-size: .14rem;
    color: #666666;
    margin-right: .32rem;
}
.f_r_top .totalResult span:nth-child(2){
    color: #1893FF;
    padding: 0 .05rem;
}
.f_r_middle{
    height: 9.75rem;
    overflow: auto;
    background-color: #ffffff;
    position: relative;
}
.f_r_bottom{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.42rem;   
}
.fileInfo{
    /* justify-content: space-between; */
    box-sizing: border-box;
    /* height: .95rem; */
    background: #f9f9f9;
    border: .01rem solid #F4F4F4;
    padding: 0.1rem .32rem ;
    flex-wrap: wrap;
}
.fileInfo:hover{
    background: #fff;
    box-shadow: 0px 59px 107px 0px rgba(0, 0, 0, 0.051);
    cursor: pointer;
}
.fileInfo:hover .fileInfo_r{
    color:#1280F9;
}
.fileInfo .fileInfo_l{
    width: 100%;
    display: flex;
    justify-content: space-between;
    /* height: 100%; */
    /* background-color: pink; */
}
.fileInfo .fileInfo_r{
    width: 1.06rem;
    height: .23rem;
    color: #999999;
    font-size: .16rem;
    margin-top: .08rem;
    /* padding-top: .08rem; */
    /* background-color: pink; */
    cursor: pointer;
}
.fileInfo .fileInfo_r:hover{
    color: #1280F9;
    font-weight:bold;
}
.fileInfo .info_title{
   color: #323232;
   font-size: .18rem;
   margin: .08rem 0;
   width:calc(100% - 1.06rem)
}
.fileInfo .info_content{
    color: #646464;
    font-size: .14rem;
    margin-bottom: .08rem;
}
.textOverflow{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.info_type{
    font-size: .12rem;
    color: #ACACAC;
    margin-right: .25rem;
}
.info_type_bm::before{
    content: '';
    display: inline-block;
    width: .17rem;
    height: .16rem;
    margin-right: .05rem;
    background: url('~@/assets/policyPage/zfjgIcon.png') no-repeat;
    background-size: 100% 100%;
}
.info_type_time::before{
    content: '';
    display: inline-block;
    width: .17rem;
    height: .16rem;
    margin-right: .05rem;
    background: url('~@/assets/policyPage/timeIcon.png') no-repeat;
    background-size: 100% 100%;
}
  .f_r_bottom >>> .el-pagination{
      color: #999999 !important;
      height: .28rem
  }
  .f_r_bottom >>> .el-pagination__total{
      color: #999999 !important;
  }
  .f_r_bottom >>> .el-pagination button:disabled{
      background-color:transparent !important;
  }
  .f_r_bottom >>> .el-pagination .btn-next, .f_r_bottom >>> .el-pagination .btn-prev{
      background:transparent !important;
      color: #999999;
  }
  .f_r_bottom >>> .el-pagination .btn-next:hover, .f_r_bottom >>> .el-pagination .btn-prev:hover{
      background:transparent !important;
      color: #1893FF;
  }
  .f_r_bottom >>> .el-pager li{
      background:transparent !important;
      font-size: .16rem;
  }
  .f_r_bottom >>> .el-pager li.active, .f_r_bottom >>> .el-pager li:hover{
    color: #1893FF;
  }
  .f_r_bottom >>> .el-pager li.btn-quicknext, .f_r_bottom >>> .el-pager li.btn-quickprev{
    color: #999999;
  }
  .f_r_bottom >>> .el-pager li.btn-quicknext:hover, .f_r_bottom >>> .el-pager li.btn-quickprev:hover{
    color: #1893FF;
  }
  .policyInterpret{
    padding-top: .54rem;
    padding-bottom:0.5rem;
  }
  .interpretType{
    justify-content: space-evenly;
    width: 100%;
    height: 1.4rem;
    margin: .33rem 0 .17rem 0;
    border-radius: .15rem;
    background-color: #ffffff;
    box-shadow: 0 0 .1rem rgba(0, 0, 0, 0.2);
  }
  .interpretType_small{
    height: 1.19rem;
    cursor: pointer;
  }
  .interpretType_small:hover{
    color:#1280F9;
  }
  .interpretType_icon{
    width: 1.54rem;
    height: 100%;
  }
  .interpretType_icon img{
    width: 100%;
    height: 100%;
  }
  .interpretType_info{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* min-width: 1.2rem; */
    margin-top: 0.1rem;
  }
  /* .interpretType_info:hover{
    color: #1280F9;
  } */
  .interpretType_i_title{
    font-size: .24rem;
    margin-bottom: .1rem;
    font-weight:bold;
  }
  .interpretType_i_text{
    font-size: .16rem;
  }
  .interpretColor1{
    color: #999999;
  }
  .interpretColor2{
    color: #1280F9;
  }
  .interpretContent{
    height: 7.66rem;
    flex-wrap: wrap;
    align-content: flex-start;
    /* background-color: pink; */
  }
  .interpret_small{
    position: relative;
    box-sizing: border-box;
    width: 4.51rem;
    height: 2.42rem;
    margin-bottom: .2rem;
    border-radius: .15rem;
    background-color: #fff;
    box-shadow: 0 0 .1rem rgba(0, 0, 0, 0.2);
  }
  .interpret_small_padding{
    padding: .26rem .26rem;
  }
  .interpret_small_padding2{
    padding: .13rem .13rem;
  }
  .interpret_small_margin{
    margin-right: .23rem;
  }
  .interpret_smallHover:hover{
    background: url('../../assets/policyPage/wzjdBg.png') no-repeat;
    background-size: 100% 100%;
  }
  .interpret_s_title{
    font-size: .22rem;
    color: #333333;
    align-items: center;
  }
  .interpret_titleIcon{
    width: .39rem;
    height: .39rem;
    margin-right: .06rem;
  }
  .interpret_s_content{
    height: .73rem;
    font-size: .16rem;
    color: #666666;
    margin: .15rem 0 0.1rem 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    line-height:0.24rem;
  }
  .interpret_detailsBtn{
    text-align: right;
    font-size: .16rem;
    color: #1280F9;
    margin-top: 0.15rem;
  }
  .interpret_detailsBtn span{
    cursor: pointer;
  }
  .interpret_detailsBtn span:hover{
    font-weight: bold;
  }
  .tpjdImg{
    width: 2.95rem;
    height: 1.64rem;
    margin: 0 auto;
    /* background-color: pink; */
  }
  .tpjdImg>>>.el-image{
    width: 100%;
    height: 100%;
  }
  .tpjdLine{
    width: 100%;
    height: .01rem;
    margin: .12rem 0 .12rem;
    background-color: #999999;
  }
  .tpjdText{
    font-size: .16rem;
    color: #999999;
    text-align: center;
    cursor: pointer;
  }
  .tpjdText:hover{
    color:#1280F9;
    font-weight: bold;
  }
  .spjdText{
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: .36rem;
    line-height:.36rem;;
    padding: 0 .1rem;
    font-size: .16rem;
    color: #ffffff;
    text-align: center;
    border-radius: 0 0 .15rem .15rem;
    background-color: rgba(68, 114, 196, 0.8);
    z-index: 9;
    cursor:pointer;
  }
  video{
    object-fit: cover;
    border-radius: .15rem .15rem .15rem .15rem;
    cursor: pointer;
  }
  .videoPlaybtn{
    position: absolute;
    top: 29%;
    left: 50%;
    transform: translateX(-50%);
    width: .86rem;
    height: .86rem;
    cursor: pointer;
  }
  .paging{
    /* height: 1rem; */
    margin-top:0.1rem;
  }
  .videoMask{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .noData{
    /* background: #fff; */
    text-align: center;
    /* box-shadow: 0 0 100px rgb(217 237 255); */
    padding: 0.5rem 0;
    /* background: none;
    box-shadow: none; */
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
    left: 50%;

  }
  .noDataText{
    color: #2996ed;
  }
  .pc-hide{
	display: none;
}
@media only screen and (max-width: 767px) {
    .mobile-hide{
		display: none!important;
	}
	.pc-hide{
		display: block;
	}
    .homeContent{
        padding-top: 0.9rem;
        min-height: calc(100vh - 0.9rem - 60px);
    }
    .mainContent{
        width: 95%;
    }
    .banner-box{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 4%;
    }
    .banner{
        position: relative;
        width: 100%;
        height: auto;
        padding-top: 19.2%;
        background: url('../../assets/policyPage/banner-mobile.png') no-repeat;
        background-size: 100% 100%;
    }
    .banner-title{
        color: #1893ff;
        margin-bottom: 5px;
        font-weight: bold;
        text-shadow: 2px 2px #bbcff6;
    }
    .banner-subtitle{
        color: #3e3e3f;
    }
    .file_left{
        width: 2rem;
    }
    .file_right{
        flex: 1;
    }
    .file_left_top{
        padding: 0.4rem 0.2rem;
    }
    .file_left_select{
        padding: 0 0.2rem;
    }
    .f_r_top .sort,.totalResult,.info_type{
        font-size: 10px;
    }
    .fileInfo .info_title{
        font-size: 0.24rem;
        max-width: 80%;
    }
    .fileInfo .fileInfo_l{
        width: 100%;
    }
    .fileInfo .fileInfo_r{
        width: fit-content;
    }
    .interpret_small_margin{
        width: 100%;
        margin: 0;
    }
    .interpret_small{
        width: 100%;
    }
    .interpretContent{
        height: fit-content;
    }
    .file_content{
        height: 12.4rem;
    }
    .f_r_middle{
        height: 11.25rem;
    }
    .noData img{
        width: 100%;
    }
    .file_left_select:hover{
        font-size: unset;
    }
}
</style>